module.exports = __webpack_public_path__ + "static/media/calendar-sync.4204faa6.svg";